// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dg-container{font-family:Roboto,sans-serif}.dg-btn-loader .dg-circle{background-color:green}.watermark{background:url(https://vonex.com.au/vonex/projects/watermark-blck.png) repeat!important}.watermarksm{background:url(https://vonex.com.au/vonex/projects/watermark-small.png) repeat!important}", ""]);
// Exports
module.exports = exports;
